export const fr = {
  title: 'Paysages de forêts vierges',
  subtitle: '(2000/2013/2016/2020)',
  download_data: 'https://data.globalforestwatch.org/documents/gfw::intact-forest-landscapes/about',
  learn_more: 'http://www.intactforests.org/',
  content: [
    {
      label: 'Fonction',
      value:
        "Identifie les derniers paysages forestiers non fragmentés du monde, suffisamment grands pour conserver toute la biodiversité indigène et ne montrant aucun signe d'altération humaine à l'horizon 2020. Cette couche montre également la réduction de l'étendue des paysages forestiers intacts entre 2000 et 2020.",
    },
    {
      label: 'Résolution',
      value: 'Approximativement 1 : 1 000 000',
    },
    {
      label: 'Couverture géographique',
      value: 'Global',
    },
    {
      label: 'Source',
      value:
        'Potapov, P., M. C. Hansen, L. Laestadius, S. Turubanova, A. Yaroshenko, C. Thies, W. Smith, I. Zhuravleva, A. Komarova, S. Minnemeyer, and E. Esipova. 2017. "The last frontiers of wilderness: Tracking loss of intact forest landscapes from 2000 to 2013." Science Advances 3: e1600821.',
    },
    {
      label: 'Date du contenu',
      value: 2020,
    },
    {
      label: 'Mises en garde',
      value:
        "La carte du monde IFL a été créée grâce aux images Landstat interprétées par des experts. La carte peut contenir des inexactitudes en raison des limitations de la résolution spatiale des images et du manque d'informations supplémentaires sur la façon dont sont utilisées les terres dans certaines régions. En outre, la méthodologie suppose que les incendies à proximité des routes ou d'autres infrastructures peuvent avoir été causés par l'homme, et constituent donc une forme de perturbation d'origine humaine. Cette hypothèse pourrait se traduire par une sous-estimation de l'IFL dan le biome boréal.",
    },
    {
      label: 'Licence',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: 'Aperçu',
    value:
      "L'ensemble de données sur les paysages forestiers intacts (Intact Forest Landscapes, IFL) identifie des étendues ininterrompues d'écosystèmes naturels dans la zone d'étendue forestière qui ne montrent aucun signe d'activité humaine significative et qui sont suffisamment grandes pour que toute la biodiversité endémique, notamment des populations viables de nombreuses espèces, puisse être maintenue. Pour cartographier les régions des IFL, un ensemble de critères a été élaboré et conçu pour être applicable à l'échelle mondiale et facilement reproductible, ce qui permet des évaluations répétées dans le temps ainsi que des vérifications. Les régions des IFL ont été définies comme des paysages non fragmentés, d'une superficie d'au moins 50 000 hectares et d'une largeur minimale de 10 kilomètres. Celles-ci ont ensuite été cartographiées à partir d'images satellite Landsat pour l'année 2000.",
  },
  citation: {
    label: 'Citation',
    value:
      'Greenpeace, University of Maryland, World Resources Institute and Transparent World. “Intact Forest Landscapes. 2000/2013/2016/2020” Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org',
  },
};
